<template>
  <div class="channel-item" :class="{ inactive: !isActive }">
    <div class="channel-item--image">
      <img :src="getChannelThumbnail()" :alt="channel.name" />
    </div>
    <div class="channel-item--type column">
      <h3 class="channel-item--title">
        {{ channel.name }}
      </h3>
      <p>
        {{ this.$t(`INBOX_MGMT.ADD.CHANNEL_LIST.${channel.key.toUpperCase()}.DESCRIPTION`) }}
      </p>
    </div>
    <div class="button-wrap">
      <woot-button icon="settings" @click="onItemClick">
        {{ $t('INBOX_MGMT.ADD.CHANNEL_LIST.CONFIGURE') }}
      </woot-button>
    </div>
  </div>
</template>
<script>
import WootButton from "../ui/WootButton.vue";
export default {
  components: {
    WootButton,
  },
  props: {
    channel: {
      type: Object,
      required: true,
    },
    enabledFeatures: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isActive() {
      const { key } = this.channel;
      if (Object.keys(this.enabledFeatures).length === 0) {
        return false;
      }
      if (key === 'website') {
        return this.enabledFeatures.channel_website;
      }
      if (key === 'facebook') {
        return this.enabledFeatures.channel_facebook;
      }
      if (key === 'twitter') {
        return this.enabledFeatures.channel_twitter;
      }
      if (key === 'email') {
        return this.enabledFeatures.channel_email;
      }

      return [
        'website',
        'twilio',
        'api',
        'whatsapp',
        'sms',
        'telegram',
        'line',
        'voll360',
        'wetalkie',
        'omne',
        'multimedia',
        'zendesk',
        'infobip',
        'instagram',
      ].includes(key);
    },
  },
  methods: {
    getChannelThumbnail() {
      if (this.channel.key === 'api' && this.channel.thumbnail) {
        return this.channel.thumbnail;
      }
      return `/assets/images/dashboard/channels/${this.channel.key}.png`;
    },
    onItemClick() {
      if (this.isActive) {
        this.$emit('channel-item-click', this.channel.key);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.channel-item {
  display: flex;
  background: var(--white);
  border: 1px solid var(--color-border-light);
  border-radius: var(--space-smaller);
  margin-bottom: var(--space-normal);
  padding: var(--space-normal);
  align-items: center;

  &.inactive {
    filter: grayscale(100%);
    opacity: 0.6;
    pointer-events: none;
  }

  .channel-item--image {
    display: flex;
    height: 6rem;
    width: 6rem;
    flex-shrink: 0;

    img {
      max-width: 100%;
      padding: var(--space-small);
      margin: auto;
    }
  }

  .channel-item--type {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 var(--space-normal);
    flex-grow: 1;

    .channel-item--title {
      font-size: var(--font-size-large);
      color: var(--color-body);
      margin-bottom: var(--space-micro);
    }

    p {
      color: var(--b-500);
      margin-bottom: 0;
      font-size: var(--font-size-default);
    }
  }

  .button-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
    flex-shrink: 0;

    ::v-deep button {
      margin-bottom: 0;
    }
  }
}
</style>
